(() => {
  if (customElements.get('ss-incense-portal')) return;

  function loadThree(url) {
    if (window.THREE?.REVISION === '160') return Promise.resolve(window.THREE);
    if (window.ssIncenseThreeReady) return window.ssIncenseThreeReady;
    window.ssIncenseThreeReady = new Promise((resolve, reject) => {
      const previous = window.THREE;
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = () => {
        const library = window.THREE;
        if (previous) window.THREE = previous;
        if (library) resolve(library);
        else reject(new Error('3D library unavailable'));
      };
      script.onerror = () => reject(new Error('3D library unavailable'));
      document.head.appendChild(script);
    });
    return window.ssIncenseThreeReady;
  }

  function createScene(THREE, root) {
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, powerPreference: 'low-power' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
    renderer.setClearColor(0xcfb998);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = .92;
    renderer.shadowMap.enabled = false;
const scene=new THREE.Scene();scene.fog=new THREE.Fog(0xc1a987,12,25);
    const camera=new THREE.PerspectiveCamera(36,1,.1,60);
    const world=new THREE.Group();scene.add(world);
    const envScene=new THREE.Scene();envScene.background=new THREE.Color(0x746a59);
    const envRoom=new THREE.Mesh(new THREE.BoxGeometry(18,16,18),new THREE.MeshBasicMaterial({color:0x827764,side:THREE.BackSide}));envScene.add(envRoom);
    function softbox(w,h,x,y,z,intensity){const m=new THREE.Mesh(new THREE.PlaneGeometry(w,h),new THREE.MeshBasicMaterial({color:new THREE.Color(intensity,intensity*.94,intensity*.83),side:THREE.DoubleSide}));m.position.set(x,y,z);m.lookAt(0,1,0);envScene.add(m);}
    softbox(3,12,-7,3,3,4);softbox(2,11,7,3,1,3);softbox(9,4,0,7,0,3);softbox(5,7,0,2,8,1.8);
    const pmrem=new THREE.PMREMGenerator(renderer);const environment=pmrem.fromScene(envScene,.1);scene.environment=environment.texture;pmrem.dispose();
    
    const ivory=new THREE.MeshStandardMaterial({color:0xcbbca0,roughness:.91});
    const stone=new THREE.MeshStandardMaterial({color:0xb4a083,roughness:.84});
    const metalTexture=new THREE.TextureLoader().load(root.dataset.metalUrl, () => {
      if (root.graphics?.metalTexture !== metalTexture) return;
      root.graphics.textureReady = true;
      root.wake();
    });
    metalTexture.colorSpace=THREE.SRGBColorSpace;
    metalTexture.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());
    const gold=new THREE.MeshBasicMaterial({map:metalTexture,color:0xffffff,toneMapped:false});
    const goldEdge=new THREE.MeshStandardMaterial({color:0xa68b53,metalness:.68,roughness:.36});
    const darkgold=new THREE.MeshStandardMaterial({color:0x89662e,metalness:.63,roughness:.34});
    const palegold=new THREE.MeshStandardMaterial({color:0xdcc084,metalness:.72,roughness:.25});
    const led=new THREE.MeshBasicMaterial({color:0xffe2a0});
    const bright=new THREE.MeshBasicMaterial({color:0xfff2d5});
    const ambient=new THREE.HemisphereLight(0xffeed0,0x654528,2.2);scene.add(ambient);
    const key=new THREE.DirectionalLight(0xffefd4,3.2);key.position.set(-3,8,7);key.castShadow=false;key.shadow.mapSize.set(1024,1024);key.shadow.camera.left=-7;key.shadow.camera.right=7;key.shadow.camera.top=9;key.shadow.camera.bottom=-4;key.shadow.normalBias=.025;scene.add(key);
    const fill=new THREE.DirectionalLight(0xfff7e1,1.8);fill.position.set(5,4,1);scene.add(fill);
    const backLight=new THREE.PointLight(0xffdb91,8,12,2);backLight.position.set(0,3.9,-2.2);scene.add(backLight);
    function box(w,h,d,x,y,z,mat=gold,parent=world){const m=new THREE.Mesh(new THREE.BoxGeometry(w,h,d),mat);m.position.set(x,y,z);m.castShadow=true;m.receiveShadow=true;parent.add(m);return m;}
    function archPath(w,h,bottom=0){const p=new THREE.Shape();p.moveTo(-w,bottom);p.lineTo(-w,h*.59);p.bezierCurveTo(-w,h*.81,-w*.26,h*.80,0,h);p.bezierCurveTo(w*.26,h*.80,w,h*.81,w,h*.59);p.lineTo(w,bottom);p.lineTo(-w,bottom);return p;}
    function archRing(w,h,border,depth,z,material,parent=world){const shape=new THREE.Shape();const wi=w-border,hi=h-border*1.25;shape.moveTo(-w,0);shape.lineTo(-w,h*.59);shape.bezierCurveTo(-w,h*.81,-w*.26,h*.80,0,h);shape.bezierCurveTo(w*.26,h*.80,w,h*.81,w,h*.59);shape.lineTo(w,0);shape.lineTo(wi,0);shape.lineTo(wi,hi*.59);shape.bezierCurveTo(wi,hi*.81,wi*.26,hi*.80,0,hi);shape.bezierCurveTo(-wi*.26,hi*.80,-wi,hi*.81,-wi,hi*.59);shape.lineTo(-wi,0);shape.closePath();const geo=new THREE.ExtrudeGeometry(shape,{depth,bevelEnabled:true,bevelSegments:2,steps:1,bevelSize:.018,bevelThickness:.016,curveSegments:36});const uv=geo.attributes.uv,pos=geo.attributes.position;for(let i=0;i<uv.count;i++){uv.setXY(i,pos.getX(i)/(w*2)+.5,pos.getY(i)/h);}uv.needsUpdate=true;const mesh=new THREE.Mesh(geo,material===gold?[gold,goldEdge]:material);mesh.position.z=z;mesh.castShadow=true;mesh.receiveShadow=true;parent.add(mesh);return mesh;}
    archRing(1.77,5.75,.12,.33,.05,gold);
    archRing(1.792,5.78,.020,.38,.035,darkgold);
    archRing(1.645,5.59,.020,.16,.34,led);
    archRing(1.665,5.62,.016,.22,.40,palegold);
    archRing(1.618,5.56,.014,.04,.36,bright);
    archRing(1.645,5.59,.065,.76,-.72,stone);
    for(const side of [-1,1]){
      box(20,12,.75,side*11.79,6,-.5,gold);
      box(.045,5.65,.14,side*1.85,2.825,.2,gold);
      box(.018,5.52,.08,side*1.93,2.76,.14,darkgold);
      box(.29,.10,.46,side*1.7,.06,.13,gold);
      box(.020,3.6,.065,side*1.60,1.8,-.44,bright);
      const light=new THREE.PointLight(0xffd383,2.5,3.5,1.8);light.position.set(side*1.35,2,-.55);scene.add(light);
    }
    box(16,.2,20,0,-.13,-4,stone);
    box(12,8,.25,0,4,-6,new THREE.MeshStandardMaterial({color:0xa58e70,roughness:1}));
    for(const z of [-2.1,-4.15]){
      archRing(1.92,5.85,.055,.16,z,gold);
      archRing(1.86,5.78,.012,.03,z+.19,led);
    }
    box(.06,5.3,5,1.91,2.65,-3.25,ivory);box(.06,5.3,5,-1.91,2.65,-3.25,ivory);
    for(const z of [-.52,-1.2,-2.5,-4])box(3.0,.012,.015,0,-.019,z,new THREE.MeshStandardMaterial({color:0x927c59,roughness:.6}));
    box(3.95,.055,.55,0,-.02,.40,palegold);
    const hazeMat=new THREE.ShaderMaterial({transparent:true,depthWrite:false,uniforms:{uTime:{value:0}},vertexShader:'varying vec2 vUv; void main(){vUv=uv;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}',fragmentShader:`varying vec2 vUv;
uniform float uTime;
float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
float noise(vec2 p){
  vec2 i=floor(p),f=fract(p);f=f*f*(3.0-2.0*f);
  return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);
}
float fbm(vec2 p){
  float v=0.,a=.5;
  for(int i=0;i<4;i++){v+=a*noise(p);p=p*2.03+vec2(7.2,3.6);a*=.5;}
  return v;
}
float wisp(vec2 p,float origin,float phase){
  float y=p.y,t=uTime*.16+phase;
  float turn=sin(y*11.-t)*(.008+y*.065)+sin(y*23.-t*.72)*y*.014;
  float curl=(fbm(vec2(y*4.5-t*.18,phase+t*.09))-.5)*y*.15;
  float center=origin+turn+curl+(origin-.5)*y*.10;
  float width=.009+y*.036;
  float core=exp(-pow((p.x-center)/width,2.));
  float veil=exp(-pow((p.x-center-width*.8)/(width*2.7),2.))*.32;
  float flow=fbm(vec2((p.x-center)*28.,y*7.-t*.7)+phase);
  return (core*.68+veil)*(.35+flow*.9)*smoothstep(.01,.16,y)*(1.-smoothstep(.65,.98,y));
}
void main(){
  vec2 p=vUv;
  float smoke=wisp(p,.29,0.)+wisp(p,.71,3.4)*.82;
  float soft=fbm(vec2(p.x*4.,p.y*6.-uTime*.015));
  float edge=smoothstep(0.,.16,p.x)*(1.-smoothstep(.84,1.,p.x));
  float centerCalm=1.-.35*exp(-pow((p.x-.5)/.17,2.))*smoothstep(.35,.7,p.y);
  float alpha=smoke*.30*edge*centerCalm;
  vec3 color=mix(vec3(.63,.56,.46),vec3(.97,.94,.86),smoothstep(.3,.65,soft));
  gl_FragColor=vec4(color,alpha);
}
`});
    const haze=new THREE.Mesh(new THREE.PlaneGeometry(3.1,5.3),hazeMat);haze.position.set(0,2.65,-.9);world.add(haze);
    
    haze.visible = root.dataset.smoke !== 'false';
    return { renderer, scene, camera, hazeMat, envScene, metalTexture, environment, textureReady: false };
  }

  class SSIncensePortal extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      const connectionSignal = this.signal;
      this.sceneHost = this.querySelector('.ss-scene');
      this.panel = this.querySelector('.ss-catalogue');
      this.intro = this.querySelector('.ss-intro');
      this.explore = this.querySelector('.ss-explore');
      this.motionButton = this.querySelector('.ss-motion');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduce.matches || this.dataset.motion === 'false' || document.documentElement.classList.contains('sf-motion-paused');
      this.classList.toggle('ss-reduced', this.reduce.matches);
      this.targetX = 0;
      this.targetY = 0;
      this.cx = 0;
      this.cy = 0;
      this.elapsed = 0;
      this.entrance = 0;
      this.graphicsFailed = false;
      this.imagesReady = false;
      this.scrollOffset = 0;
      this.visible = false;
      this.last = performance.now();
      this.renderInterval = 1000 / 30;
      this.lastRender = 0;
      this.targetScroll = Math.max(0, -this.getBoundingClientRect().top);
      this.updatePause();
      this.listen(this.explore, 'click', event => {
        event.preventDefault();
        const top = this.panel.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: Math.max(0, top), behavior: this.reduce.matches ? 'instant' : 'smooth' });
      });
      this.listen(document, 'sf:motion', event => { this.paused = event.detail.paused || this.reduce.matches; this.updatePause(); this.wake(); });
      this.listen(this.motionButton, 'click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.wake();
      });
      this.listen(this.reduce, 'change', () => {
        this.paused = this.reduce.matches || this.dataset.motion === 'false' || document.documentElement.classList.contains('sf-motion-paused');
        this.classList.toggle('ss-reduced', this.reduce.matches);
        this.updatePause();
        this.wake();
      });
      this.querySelectorAll('.ss-shelf').forEach(shelf => {
        const rail = shelf.querySelector('.ss-rail');
        const previous = shelf.querySelector('[data-direction="previous"]');
        const next = shelf.querySelector('[data-direction="next"]');
        const state = () => {
          previous.disabled = rail.scrollLeft < 3;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
        };
        const move = direction => {
          const tile = rail.querySelector('.ss-tile');
          if (!tile) return;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
          rail.scrollBy({ left: direction * (tile.getBoundingClientRect().width + gap), behavior: this.reduce.matches ? 'instant' : 'smooth' });
        };
        this.listen(previous, 'click', () => move(-1));
        this.listen(next, 'click', () => move(1));
        this.listen(rail, 'scroll', state, { passive: true });
        const observer = new ResizeObserver(state);
        observer.observe(rail);
        (this.railObservers ||= []).push(observer);
        state();
      });
      this.listen(window, 'scroll', () => { this.scrollDirty = true; this.wake(); }, { passive: true });
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) this.stop();
        else { this.scheduleGraphics(); this.wake(); }
      });
      this.listen(this.sceneHost, 'pointermove', event => {
        if (this.paused || event.pointerType !== 'mouse') return;
        const r = this.sceneHost.getBoundingClientRect();
        this.targetX = Math.max(-1, Math.min(1, ((event.clientX - r.left) / r.width - .5) * 2));
        this.targetY = Math.max(-1, Math.min(1, ((event.clientY - r.top) / r.height - .5) * 2));
        this.wake();
      });
      this.listen(this.sceneHost, 'pointerleave', () => { this.targetX = 0; this.targetY = 0; this.wake(); });
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) { this.scheduleGraphics(); this.wake(); }
        else this.stop();
      });
      this.intersection.observe(this.sceneHost);
      this.resize = new ResizeObserver(() => { this.size(); this.scrollDirty = true; this.wake(); });
      this.resize.observe(this.sceneHost);
      this.wake();
      const heroImages = Array.from(this.sceneHost.querySelectorAll('img:not([loading="lazy"])'));
      const readyImages = heroImages.map(image => image.complete ? Promise.resolve() : new Promise(resolve => {
        image.addEventListener('load', resolve, { once: true, signal: this.signal });
        image.addEventListener('error', resolve, { once: true, signal: this.signal });
      }));
      Promise.all(readyImages).then(() => {
        if (!this.isConnected || connectionSignal.aborted) return;
        this.imagesReady = true;
        this.scheduleGraphics();
      });
    }

    scheduleGraphics() {
      if (!this.imagesReady || this.graphicsStarted || this.preloadFrame || this.graphicsIdle != null || this.graphicsTimer != null || !this.visible || document.hidden || !this.isConnected) return;
      const signal = this.signal;
      this.preloadFrame = requestAnimationFrame(() => {
        this.preloadFrame = requestAnimationFrame(() => {
          this.preloadFrame = null;
          const begin = () => {
            this.graphicsIdle = null;
            this.graphicsTimer = null;
            if (!signal.aborted && this.visible && !document.hidden) this.startGraphics();
          };
          if ('requestIdleCallback' in window) this.graphicsIdle = requestIdleCallback(begin, { timeout: 1800 });
          else this.graphicsTimer = setTimeout(begin, 120);
        });
      });
    }

    startGraphics() {
      if (this.graphicsStarted) return;
      this.graphicsStarted = true;
      const signal = this.signal;
      loadThree(this.dataset.threeUrl).then(THREE => {
        if (!this.isConnected || signal.aborted) return;
        if (!this.visible || document.hidden) { this.graphicsStarted = false; return; }
        try {
          this.graphics = createScene(THREE, this);
          const canvas = this.graphics.renderer.domElement;
          canvas.setAttribute('aria-hidden', 'true');
          this.sceneHost.prepend(canvas);
          this.listen(canvas, 'webglcontextlost', () => {
            this.classList.remove('ss-ready');
            this.graphicsFailed = true;
            this.stop();
          });
          this.size();
          this.wake();
        } catch (error) {
          this.disposeGraphics();
          console.warn('Sara Sakina entrance: showing static arch.', error);
        }
      }).catch(() => { if (!signal.aborted) this.graphicsFailed = true; });
    }

    listen(target, type, handler, options = {}) {
      target.addEventListener(type, handler, { ...options, signal: this.signal });
    }

    updatePause() {
      this.classList.toggle('ss-paused', this.paused);
      this.classList.toggle('ss-reduced', this.paused);
      this.motionButton.textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
      this.motionButton.setAttribute('aria-pressed', String(this.paused));
    }

    size() {
      const width = this.sceneHost.clientWidth;
      const height = this.sceneHost.clientHeight;
      this.heroHeight = height;
      const brand = this.querySelector('.ss-brand');
      if (brand) brand.style.width = Math.min(width >= 750 ? 300 : 225, width * .56) + 'px';
      if (!this.graphics || !width || !height) return;
      if (this.graphics.width === width && this.graphics.height === height) return;
      this.graphics.width = width;
      this.graphics.height = height;
      this.lastRender = 0;
      const { renderer, camera } = this.graphics;
      renderer.setSize(width, height);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
      camera.userData.distance = Math.max(10.1, 4.25 / (2 * Math.tan(18 * Math.PI / 180) * camera.aspect));
      camera.zoom = 1.04; camera.updateProjectionMatrix();
      camera.position.set(0, 2.4, camera.userData.distance);
      camera.lookAt(0, 2.41, -.5);
    }

    wake() {
      if (this.frameId || !this.isConnected || !this.visible || document.hidden) return;
      this.last = performance.now();
      this.frameId = requestAnimationFrame(time => this.frame(time));
    }

    frame(now) {
      this.frameId = null;
      if (!this.isConnected || !this.visible || document.hidden) return;
      const dt = Math.min((now - this.last) / 1000, .06);
      this.last = now;
      if (this.scrollDirty) { this.targetScroll = Math.max(0, -this.getBoundingClientRect().top); this.scrollDirty = false; }
      const targetScroll = this.targetScroll;
      if (!this.paused) {
        this.elapsed += dt;
        this.entrance += dt;
        const damping = 1 - Math.exp(-dt * 6);
        this.cx += (this.targetX - this.cx) * damping;
        this.cy += (this.targetY - this.cy) * damping;
      } else {
        const decay = Math.exp(-dt * 8);
        this.cx *= decay;
        this.cy *= decay;
      }
      this.scrollOffset += (targetScroll - this.scrollOffset) * (this.reduce.matches ? 1 : 1 - Math.exp(-dt * 16));
      const progress = Math.min(1, Math.max(0, this.scrollOffset / 340));
      const calm = 1 - progress;
      this.intro.style.transform = 'translate3d(' + (-this.cx * 1.4 * calm) + 'px,' + (-progress * 145 + this.cy * calm) + 'px,0) scale(' + (1 - progress * .48) + ')';
      this.explore.style.opacity = String(Math.max(0, 1 - progress * 3));
      this.explore.style.visibility = progress > .34 ? 'hidden' : 'visible';
      this.motionButton.style.opacity = String(Math.max(0, 1 - progress * 3));
      this.motionButton.style.visibility = progress > .34 ? 'hidden' : 'visible';
      if (this.graphics?.textureReady && !this.graphicsFailed && (!this.lastRender || now - this.lastRender >= this.renderInterval - 1)) {
        this.lastRender = now;
        const { camera, renderer, scene, hazeMat } = this.graphics;
        const zoom = this.reduce.matches ? 0 : .14 * Math.pow(1 - Math.min(this.entrance / 2.4, 1), 3);
        camera.position.set(this.cx * .18 * calm, 2.4 - this.cy * .045 * calm, camera.userData.distance + zoom);
        camera.lookAt(this.cx * .025 * calm, 2.41, -.5);
        hazeMat.uniforms.uTime.value = this.elapsed;
        renderer.render(scene, camera);
        this.classList.add('ss-ready');
      }
      const targetX = this.paused ? 0 : this.targetX;
      const targetY = this.paused ? 0 : this.targetY;
      const unsettled = Math.abs(targetScroll - this.scrollOffset) > .1 || Math.abs(targetX - this.cx) + Math.abs(targetY - this.cy) > .002;
      const ambient = this.graphics?.textureReady && !this.graphicsFailed && !this.paused && (this.dataset.smoke !== 'false' || this.entrance < 2.4) && targetScroll < (this.heroHeight || 640);
      if (ambient || unsettled) {
        this.frameId = requestAnimationFrame(time => this.frame(time));
      }
    }

    stop() {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }

    disposeGraphics() {
      if (!this.graphics) return;
      const { renderer, scene, envScene, metalTexture, environment } = this.graphics;
      const geometries = new Set();
      const materials = new Set();
      [scene, envScene].forEach(tree => tree.traverse(object => {
        if (object.geometry) geometries.add(object.geometry);
        if (object.material) (Array.isArray(object.material) ? object.material : [object.material]).forEach(material => materials.add(material));
      }));
      geometries.forEach(geometry => geometry.dispose());
      materials.forEach(material => material.dispose());
      metalTexture.dispose();
      environment.dispose();
      renderer.dispose();
      renderer.domElement.remove();
      this.graphics = null;
      this.classList.remove('ss-ready');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.stop();
      cancelAnimationFrame(this.preloadFrame);
      if (this.graphicsIdle != null && 'cancelIdleCallback' in window) cancelIdleCallback(this.graphicsIdle);
      clearTimeout(this.graphicsTimer);
      this.preloadFrame = null;
      this.graphicsIdle = null;
      this.graphicsTimer = null;
      this.graphicsStarted = false;
      this.frameId = null;
      this.intersection?.disconnect();
      this.resize?.disconnect();
      this.railObservers?.forEach(observer => observer.disconnect());
      this.railObservers = [];
      this.disposeGraphics();
    }
  }

  customElements.define('ss-incense-portal', SSIncensePortal);
})();
